import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { entityMessages } from 'src/features/entity/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';
import { pageTitles } from 'src/features/navigation/utils/messages';
import { PERMISSION } from 'src/features/auth';
import useHasPermissions from 'src/hooks/useHasPermissions';
import MainLayout from 'src/components/layout/MainLayout';
import TabRow from 'src/registry/components/navigation/TabRow';
import Tab from 'src/registry/components/navigation/Tab';
import { PATH } from 'src/features/navigation/utils/constants';
import { Outlet } from 'react-router-dom';

const EntitiesLayout = () => {
    const { formatMessage } = useIntl();
    const permissionAccessEntities = useHasPermissions([PERMISSION.ACCESS_ENTITIES]);

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(pageTitles.entitiesCRM));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            {permissionAccessEntities && (
                <TabRow>
                    <Tab to={`/${PATH.ENTITIES}/people`}>
                        <FormattedMessage {...entityMessages.people} />
                    </Tab>
                    <Tab to={`/${PATH.ENTITIES}/organisations`}>
                        <FormattedMessage {...entityMessages.groups} />
                    </Tab>
                </TabRow>
            )}
            <Outlet />
        </MainLayout>
    );
};

export default EntitiesLayout;
